import axios from "../../api-client";

export const getSocials = () => {
    return axios.get("/api/instagram-posts").then(response => response.data);
}
